import useQueryGetRankExperienceSetting from '@/modules/manage-rank/api/hooks/useQueryGetRankExperienceSetting'
import useMutationUpdateRankExperienceSetting from '@/modules/manage-rank/api/hooks/useMutationUpdateRankExperienceSetting'
import RankExperienceSettingForm, {
	RankExperienceSettingFormValues,
} from './RankExperienceSettingForm'
import Spinner from '@/common/components/Spinner'
import { Card, CardContent } from '@/common/ui/card'

export default function RankExperienceSetting() {
	const { data, isLoading } = useQueryGetRankExperienceSetting()
	const updateMutation = useMutationUpdateRankExperienceSetting()

	const handleSubmit = (formData: RankExperienceSettingFormValues) => {
		updateMutation.mutate(formData)
	}

	if (isLoading) {
		return (
			<Card>
				<CardContent className="p-6">
					<div className="flex h-32 items-center justify-center">
						<Spinner />
					</div>
				</CardContent>
			</Card>
		)
	}

	if (!data) {
		return (
			<Card>
				<CardContent className="p-6">
					<div className="flex h-32 items-center justify-center">
						<div className="text-muted-foreground">ไม่พบข้อมูลการตั้งค่า</div>
					</div>
				</CardContent>
			</Card>
		)
	}

	const defaultValues: RankExperienceSettingFormValues = {
		depositPoint: data.depositPoint,
		turnoverPoint: data.turnoverPoint,
		winPoint: data.winPoint,
		losePoint: data.losePoint,
		withdrawPoint: data.withdrawPoint,
		promotionTurnoverPoint: data.promotionTurnoverPoint,
	}

	return (
		<RankExperienceSettingForm
			defaultValues={defaultValues}
			onSubmit={handleSubmit}
			isSubmitting={updateMutation.isPending}
		/>
	)
}
